/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendation {
    getFixupPrototypeFunction() { return PolicyRecommendation.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendation>): PolicyRecommendation {
        let obj = Object.assign(new PolicyRecommendation(), model);
        PolicyRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendation>): PolicyRecommendation {
        if (!model) return null;
        return PolicyRecommendation.newInstance(<PolicyRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendation) {
        if (!obj) return;

        models.PolicyRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendation): boolean {
        Object.setPrototypeOf(obj, PolicyRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * unique recommendation Id
     */
    recommendation_id: string;

    /**
     * recommendation name
     */
    recommendation_name: string;

    /**
     * list of policy ids for which the recommendation exists
     */
    policy_id: Array<string>;

    /**
     * resolution status of the recommendation the values will be open, resolved
     */
    status: string;

    /**
     * impact of recommended changes
     */
    impact: string;

    /**
     * classified based on the kind of recommendation provided to the user can be cost, security etc
     */
    classification: string;

    /**
     * cloud account id impacted by the recommendation
     */
    cloud_account_id: string;

    /**
     * cloud on which this account exits for which the recommendations exists
     */
    cloud: string;

    /**
     * tenant for which the recommendation exits
     */
    tenant_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * UTC time at which the recommendation was created
     */
    created_at: string;

}
